import { dataLayer } from 'analytics/data-layer';

export function trackInfoLoaded({
  classification,
  errorType = 'none',
}: {
  classification: string;
  errorType?: string;
}) {
  dataLayer.push({
    event: 'info_loaded',
    classification,
    error_type: errorType,
  });
}
